module.exports = __webpack_public_path__ + "img/savedjobs.d0a41bd2.svg";